<template>
<div>
   
<table class="table table-sm table-bordered table-hover">
    <thead class="detail_">
    <tr :style="{backgroundColor : '#9ACD32',color: 'black' ,fontSize:  '15px',fontWeight:'bold' }" >
        <th v-for="(col,index) in cols" :key="index">
            {{col}}
        </th>
    </tr>
    </thead>
    <tbody>
    <tr :style="{color: setColor(item.tipo) ,fontSize:  '14px' }"  v-for="(item, index) in rows" :key="index">
    <td v-for="(col,index) in cols" :key="index">
        {{item[col]}}
    </td>
    </tr>
    </tbody>
</table>

</div> 
</template>

<script>


export default {
   props: ['cols','rows'],
   components: {
  
   
  },
  data () {
    return { 

        color : ['#006600','#990000','#660099'],     
        
       
    }
  },
  computed: 
  {   
    
  },


  created()
  { 
      //console.log(this.rows)
  
  },
      
  mounted()
  {},
  methods: 
  {
      setColor(type)
      {
          var color = ''
          if(type == 'AC')
          {
              color = this.color[0]
          }
          if(type == 'VB')
          {
              color = this.color[1]
          }  
          if(type == 'ST')
          {
              color = this.color[2]
          }
          return color
      }
  }
  
}
</script>

<style scoped>
.detail {
    background    : yellow;
    font-family  : 'Roboto Condensed';
    font-size     : 20px;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
</style>